export default __webpack_public_path__ + "static/media/no-user-big.3f3eb56d.png";